export const SETTINGSID = {
  ACTIVE: 1,
  FAVORITE: 2,
  SERVERLESS: 999
}

export const TRIALSTATUS = {
  NEVER: 1,
  CURRENT: 2,
  EXPIRED: 3,
  CANCELED: 4
}

export const SUBSCRIPTIONDURATIONIDS = {
  ANNUAL: 3,
  MONTHLY: 4
}

export const SUBIDS = {
  PRO: 4,
  HUNT: 8,
  PRO_ADVANTAGE: 36,
  PRO_ULTIMATE: 44
}

export const SUBSCRIPTIONS = {
  BASIC: 'Basic Subscription',
  PRO: 'Pro Subscription',
  PRO_ULTIMATE: 'Pro Ultimate Subscription',
  GLOBAL_RESCUE: 'Global Rescue Subscription',
  HUNTDATA: 'Hunt Data Subscription',
  PRO_ADVANTAGE: 'Pro Advantage Subscription'
}
